import React, { Fragment } from 'react';
import './styles.scss';
import cl from 'classnames';

export default function Loader(props) {
    const { color, isPrincipal } = props;

    const renderLoader = () => (
        <div className="spinner-loader">
            <div className={cl('lds-dual-ring', color)} />
        </div>);

    const principalLoader = () => {
        return (
            <div className="principal">
                <div className='loader-container'>
                    { renderLoader() }
                </div>
            </div>
        )
    }
    return (
        <Fragment>
            {isPrincipal ?
                principalLoader() :
                renderLoader()
            }
        </Fragment>
    );
}
